import React from "react";

const Reports = ({ link = "https://app.powerbi.com/reportEmbed?reportId=eb74f2fc-6e4e-45bd-a772-580ffbae02da&autoAuth=true&ctid=f6207f8b-59d2-47ed-9ba2-8484d0dd3061" }) => {
    return (
        <div style={{ width: "100%", height: "100%", padding: "40px 0px" }}>
            <iframe title="main report megacabs" style={{ width: "100%" }} width="1140" height="541.25" src={link} frameborder="0" allowFullScreen="true"></iframe>
        </div>
    )
}

export default Reports